import type { DeviceMetric } from '../../../../services/deviceMetricTypes';
import type { MeasurementContext } from './types';
import { metricModule } from './registry';

export function measurementContext(metric: DeviceMetric, fieldPath: string): MeasurementContext | undefined {
  const module = metricModule(metric);
  const context = module.measurementContext(metric, fieldPath);
  return context ? { ...context, provider: module.id } : undefined;
}

export function relatedMeasurements(context: MeasurementContext, catalog: DeviceMetric[]) {
  return context.related.flatMap(relation => {
    const metric = catalog.find(item => item.dataType === relation.dataType &&
      (!context.provider || metricModule(item).id === context.provider));
    if (!metric || (relation.fieldPath && !metric.fields.some(field => field.path === relation.fieldPath))) return [];
    return [{ metric, fieldPath: relation.fieldPath }];
  });
}
